module.exports = __webpack_public_path__ + "img/history_icon.09a8f1a2.svg";